import { ref } from 'vue';
import { useClientAnalytics } from '@ilteducation/client-analytics';

export function useAreaGuidesAnalytics() {
  const clientAnalytics = useClientAnalytics();
  const { sendAnalyticsEvent } = clientAnalytics;

  const areaId = ref<string>();
  const setAreaId = (id: string) => {
    areaId.value = id;
  };

  const sendGoToSectionEvent = (to: number, from: number) => {
    if (!areaId.value) {
      return;
    }
    sendAnalyticsEvent('AreaGuideEventType', {
      eventName: 'go_to_section',
      areaId: areaId.value,
      fromSection: from,
      toSection: to,
    });
  };

  const sendClickLanguageButtonEvent = (currentLanguage?: string) => {
    if (!areaId.value) {
      return;
    }
    sendAnalyticsEvent('AreaGuideEventType', {
      eventName: 'click_language_button',
      areaId: areaId.value,
      currentLanguage,
    });
  };

  const sendSelectLanguageEvent = (toLanguage: string, fromLanguage?: string) => {
    if (!areaId.value) {
      return;
    }
    sendAnalyticsEvent('AreaGuideEventType', {
      eventName: 'select_language',
      areaId: areaId.value,
      toLanguage,
      fromLanguage,
    });
  };

  const sendToggleLanguageEvent = (toggledLanguage: string, toggleState: 'on' | 'off') => {
    if (!areaId.value) {
      return;
    }
    sendAnalyticsEvent('AreaGuideEventType', {
      eventName: 'toggle_language',
      areaId: areaId.value,
      toggledLanguage,
      toggleState,
    });
  };

  const sendClickCarouselEvent = (carouselKeywordId: string, carouselPosition: number) => {
    if (!areaId.value) {
      return;
    }
    sendAnalyticsEvent('AreaGuideEventType', {
      eventName: 'click_carousel',
      areaId: areaId.value,
      carouselKeywordId,
      carouselPosition,
    });
  };

  const sendScrollCarouselEvent = (scrollDirection: 'next' | 'prev', fromPosition: number, toPosition: number) => {
    if (!areaId.value) {
      return;
    }
    sendAnalyticsEvent('AreaGuideEventType', {
      eventName: 'scroll_carousel',
      areaId: areaId.value,
      scrollDirection,
      fromPosition,
      toPosition,
    });
  };

  const sendClickKeywordEvent = (toKeywordId: string, fromKeywordId?: string) => {
    if (!areaId.value) {
      return;
    }
    sendAnalyticsEvent('AreaGuideEventType', {
      eventName: 'click_keyword',
      areaId: areaId.value,
      fromKeywordId,
      toKeywordId,
    });
  };

  const sendClickVideoEvent = (videoId: string) => {
    if (!areaId.value) {
      return;
    }
    sendAnalyticsEvent('AreaGuideEventType', {
      eventName: 'click_video',
      areaId: areaId.value,
      videoId,
    });
  };

  const sendClickBookEvent = (clickedBookId: string) => {
    if (!areaId.value) {
      return;
    }
    sendAnalyticsEvent('AreaGuideEventType', {
      eventName: 'click_book',
      areaId: areaId.value,
      clickedBookId,
    });
  };

  return {
    setAreaId,
    sendGoToSectionEvent,
    sendClickLanguageButtonEvent,
    sendSelectLanguageEvent,
    sendToggleLanguageEvent,
    sendClickCarouselEvent,
    sendScrollCarouselEvent,
    sendClickKeywordEvent,
    sendClickVideoEvent,
    sendClickBookEvent,
  };
}
